import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

// components
import {
    Button,
    FormGroup,
    Input,
    Modal,
    Row,
    Col,
} from "reactstrap";

// helpers
import { formateDateandTime } from "../../helpers/formats.js";

// services
import { showMessage, showQuestion } from "../../services/message.js";
import { getSessionCookie } from "../../services/session.js";
import { api_POST, api_DELETE } from "../../services/api_service.js";

export default function ModalDetalhesInconformidade({ stateModalDetalhesInconformidade, ordemColeta, item, handleReturn, permissoesEspeciais, showLoading }) {
    const session = getSessionCookie();
    const { register, handleSubmit, errors, setError, setValue, getValues, clearErrors } = useForm({ mode: "onBlur" });

    const [stateModal, setstateModal] = React.useState(stateModalDetalhesInconformidade);

    useEffect(() => {
        setstateModal(stateModalDetalhesInconformidade);
    }, [stateModalDetalhesInconformidade]);

    const [tituloDescricao, setTituloDescricao] = React.useState("");
    useEffect(() => {
        setlistaAcoes(null);
        setTituloDescricao("");

        if (item == null)
            return;

        loadListaAcoes();

        handleExibicaoBotoes();
    }, [item]);

    const [listaAcoes, setlistaAcoes] = React.useState(null);
    const loadListaAcoes = () => {
        let acoes = [];
        item.ordemColetaContestacao.map(m => {
            acoes.push({
                id: m.ordemColetaContestacaoId,
                acao: "Contestação",
                usuario: m.usuario != null ? m.usuario.nome : "",
                data: m.dataHoraRegistro,
                descricao: m.observacoes,
                anexo: m.anexo
            });
            if (m.ordemColetaJustificativa != null) {
                m.ordemColetaJustificativa.map(n => {
                    acoes.push({
                        id: n.ordemColetaJustificativaId,
                        acao: "Justificativa",
                        usuario: n.usuario != null ? n.usuario.nome : "",
                        data: n.dataHoraRegistro,
                        descricao: n.observacoes,
                        anexo: n.anexo
                    });
                    if (n.ordemColetaAvaliacaoJustificativa != null) {
                        n.ordemColetaAvaliacaoJustificativa.map(o => {
                            acoes.push({
                                id: o.ordemColetaAvaliacaoJustificativaId,
                                acao: "Avaliação",
                                usuario: o.usuario != null ? o.usuario.nome : "",
                                data: o.dataHoraRegistro,
                                descricao: o.observacoes,
                                anexo: o.anexo
                            });
                        })
                    }
                })
            }
        })
        if (acoes.length > 0) {
            acoes = acoes.sort((a, b) => new Date(a.data) - new Date(b.data))
            setlistaAcoes(acoes);
        }
    }
    const handleDescricaoAcao = (descricao) => {
        showMessage("", descricao, 'info', null);
    }

    const [anexo, setanexo] = React.useState(null);
    const handleAnexo = (event) => {
        if (event.target.files.length) {
            var reader = new FileReader();
            let _file = event.target.files[0];
            reader.readAsDataURL(_file);
            reader.onloadend = function () {
                var base64data = reader.result;
                setanexo({
                    base64: base64data.split(',')[1],
                    name: uuidv4() + '.' + _file.name.split('.').pop().toLowerCase()
                });
            }
        }
    }

    const [exibicaoBotaoContestar, setexibicaoBotaoContestar] = React.useState(false);
    const [exibicaoBotaoJustificar, setexibicaoBotaoJustificar] = React.useState(false);
    const [exibicaoBotaoAprovar, setexibicaoBotaoAprovar] = React.useState(false);
    const [exibicaoBotaoReprovar, setexibicaoBotaoReprovar] = React.useState(false);
    const [exibicaoBotaoExcluir, setexibicaoBotaoExcluir] = React.useState(false);

    const handleExibicaoBotoes = () => {
        if (item != null
            && (item.situacao == "Aguardando Contestação" || item.situacao == "Aguardando Avaliação de Justificativa")
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada" || ordemColeta.statusAvaliacaoOrdemColeta == "Aprovação Automática")
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "contestar_os").length > 0)) {
            setexibicaoBotaoContestar(true);
            setTituloDescricao("Descrição da Contestação");
        }

        if (item != null && item.situacao == "Aguardando Justificativa" && ordemColeta.statusAvaliacaoOrdemColeta == "Contestada"
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "justificar_os").length > 0)) {
            setexibicaoBotaoJustificar(true);
            setTituloDescricao("Descrição da Justificativa");
        }

        if (item != null
            && (item.situacao == "Aguardando Avaliação de Justificativa" || (item.situacao == "Aguardando Justificativa" && session.perfil == "Gestor"))
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada")
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "aprovar_os").length > 0)) {
            setexibicaoBotaoAprovar(true);
            setTituloDescricao("Descrição da Avaliação");
        }

        if (item != null && item.situacao == "Aguardando Avaliação de Justificativa"
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada")
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "reprovar_os").length > 0)) {
            setexibicaoBotaoReprovar(true);
            setTituloDescricao("Descrição da Avaliação");
        }

        if (item != null && (item.situacao == "Aguardando Contestação" || item.situacao == "Aguardando Justificativa") && ordemColeta.statusAvaliacaoOrdemColeta != "Contestada" && item.registroManual == true && (session.perfil === "Gestor" || session.perfil === "Master")) {
            setexibicaoBotaoExcluir(true);
        }
    }

    const Contestar = () => {
        let data = getValues();
        if (data.descricao == "") {
            setError("descricao");
            return;
        }

        let json_post = {
            ordemColetaInconformidadeId: item.ordemColetaInconformidadeId,
            observacoes: data.descricao,
            usuarioId: session.usuarioId,
            anexo: anexo != null ? anexo.name : null,
            anexoBase64: anexo != null ? anexo.base64 : null,
            usuarioAtualizacaoId: session.usuarioId
        }
        showLoading(true);
        api_POST('AvaliacaoColeta/ContestarInconformidade', json_post).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Atenção", "Inconformidade contestada!", 'success', function () { handleReturn(result.data) });
            }
        });
    }

    const Justificar = () => {
        let data = getValues();
        if (data.descricao == "") {
            setError("descricao");
            return;
        }

        let json_post = {
            ordemColetaContestacaoId: item.ordemColetaContestacao.filter(f => f.ordemColetaJustificativa.length == 0)[0].ordemColetaContestacaoId,
            observacoes: data.descricao,
            usuarioId: session.usuarioId,
            anexo: anexo != null ? anexo.name : null,
            anexoBase64: anexo != null ? anexo.base64 : null
        }

        showLoading(true);
        api_POST(`AvaliacaoColeta/JustificarInconformidade/${ordemColeta.ordemColetaId}/${item.ordemColetaInconformidadeId}`, json_post).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Atenção", "Contestação justificada!", 'success', function () { handleReturn(result.data) });
            }
        });
    }

    const AvaliarJustificativa = (aprovada) => {
        let data = getValues();
        if (data.descricao == "") {
            setError("descricao");
            return;
        }

        let json_post = {
            ordemColetaJustificativaId: item.ordemColetaContestacao.filter(f => f.ordemColetaJustificativa.length > 0 && f.ordemColetaJustificativa.filter(i => i.ordemColetaAvaliacaoJustificativa.length == 0).length > 0).sort((a, b) => b.ordemColetaContestacaoId - a.ordemColetaContestacaoId)[0].ordemColetaJustificativa[0].ordemColetaJustificativaId,
            observacoes: data.descricao,
            usuarioId: session.usuarioId,
            anexo: anexo != null ? anexo.name : null,
            anexoBase64: anexo != null ? anexo.base64 : null,
            aprovada: aprovada
        }

        showLoading(true)
        api_POST(`AvaliacaoColeta/AvalidarJustificativa/${ordemColeta.ordemColetaId}/${item.ordemColetaInconformidadeId}`, json_post).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Atenção", "Justificativa Avaliada!", 'success', function () { handleReturn(result.data) });
            }
        });
    }

    const ExcluirOrdemColetaInconformidade = () => {
        showQuestion("Aviso", "Tem certeza que deseja excluir o registro?", 'question', function (result) {
            if (result) {
                showLoading(true)
                api_DELETE(`AvaliacaoColeta/ExcluirInconformidade/${session.usuarioId}/${item.ordemColetaInconformidadeId}`).then(result => {
                    if (result.status !== 200) {
                        showLoading(false)
                        showMessage("Aviso", result.message, 'error', null);
                    } else {
                        showLoading(false);
                        showMessage("Atenção", "Inconformidade excluída com sucesso!", 'success', function () { handleReturn(result.data) });
                    }
                })
            }
        });
    }

    const Return = () => {
        setexibicaoBotaoContestar(false);
        setexibicaoBotaoJustificar(false);
        setexibicaoBotaoAprovar(false);
        setexibicaoBotaoReprovar(false);
        setexibicaoBotaoExcluir(false);
        handleReturn();
    }


    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"
            >
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                        Detalhes da {item != null && item.categoria}
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleReturn()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Data/Hora
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="categoria"
                                    type="text"
                                    value={item != null && formateDateandTime(item.dataHoraInconsistencia)}
                                    disabled="true"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Usuário
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="usuario"
                                    type="text"
                                    value={item != null && item?.usuario?.nome}
                                    disabled="true"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="5">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Situação
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="situacao"
                                    type="text"
                                    value={item != null && item.situacao}
                                    disabled="true"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Inconformidade
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricao"
                                    type="text"
                                    value={item != null ? (item.justificativa != null ? item.justificativa.descricao : item.tipoInconsistencia) : ""}
                                    disabled="true"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Dados Adicionais
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricao"
                                    type="textarea"
                                    value={item != null && item.dadosAdicionais}
                                    disabled="true"
                                />
                            </FormGroup>
                        </Col>
                        {(item != null && item.anexo != null) &&
                            <Col md="12">
                                <a style={{ fontSize: "14px" }} href={session.pathVirtual + item.anexo} target="_blank">Visualizar Anexo da Inconformidade</a>
                            </Col>
                        }
                    </Row>
                    {listaAcoes != null &&
                        <div className="mt-4">
                            <h4 className="modal-title" id="modal-title-default">
                                Lista de Ações
                            </h4>
                            <table class="table align-items-center mt-4">
                                <thead class="thead-light">
                                    <tr>
                                        <th scope="col" class="sort" data-sort="status">Data</th>
                                        <th scope="col" class="sort" data-sort="name">Ação</th>
                                        <th scope="col" class="sort" data-sort="budget">Usuário</th>
                                        <th scope="col">Ação a ser executada</th>
                                        <th scope="col" class="sort" data-sort="completion">Anexo</th>
                                    </tr>
                                </thead>
                                <tbody class="list">
                                    {listaAcoes.map(m => (
                                        <tr key={m.id}>
                                            <td>{formateDateandTime(m.data)}</td>
                                            <td>{m.acao}</td>
                                            <td>{m.usuario}</td>
                                            <td style={{ cursor: "pointer" }} onClick={() => handleDescricaoAcao(m.descricao)}>{m.descricao != null && m.descricao.substring(0, 20) + "..."}
                                            </td>
                                            <td>{m.anexo != null && <a href={session.pathVirtual + m.anexo} target="_blank">Anexo</a>}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                    {tituloDescricao != "" &&
                        <div>
                            <Row className="mt-4">
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            {tituloDescricao}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="descricao"
                                            placeholder="Descrição"
                                            type="textarea"
                                            innerRef={register({ required: true })}
                                        />
                                        {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Importar Arquivo
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            defaultValue=""
                                            name="arquivo"
                                            placeholder="Anexar Arquivo"
                                            type="file"
                                            onChange={handleAnexo}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    }
                </div>
                <div className="modal-footer">
                    {exibicaoBotaoContestar &&
                        <Button color="warning" type="button" onClick={() => Contestar()}>
                            Contestar
                        </Button>
                    }
                    {exibicaoBotaoJustificar &&
                        <Button color="success" type="button" onClick={() => Justificar()}>
                            Justificar
                        </Button>
                    }
                    {exibicaoBotaoAprovar &&
                        <Button color="success" type="button" onClick={() => AvaliarJustificativa(true)}>
                            Aprovar
                        </Button>
                    }
                    {exibicaoBotaoReprovar &&
                        <Button color="danger" type="button" onClick={() => AvaliarJustificativa(false)}>
                            Reprovar
                        </Button>
                    }
                    {exibicaoBotaoExcluir &&
                        <Button color="danger" type="button" onClick={ExcluirOrdemColetaInconformidade}>
                            Excluir
                        </Button>
                    }

                    <Button color="secondary" type="button" onClick={() => Return()}>
                        Fechar
                    </Button>
                </div>
            </Modal>
        </>
    );
}
